import React, { useEffect } from 'react';

const CustomModal = ({ isOpen, onClose, onSave, title, children, isDisabled = false }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className='modal fade show d-block bg-dark bg-opacity-75'
      tabIndex='-1'
      role='dialog'
      onClick={onClose ? onClose : undefined}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
      }}
    >
      <div
        className='modal-dialog modal-dialog-scrollable modal-dialog-centered'
        role='document'
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '900px', width: '100%' }}
      >
        <div className='modal-content'>
          <div className='modal-header position-relative'>
            <h4 className='modal-title position-absolute top-50 start-50 translate-middle m-0'>
              {title}
            </h4>
            {onClose && (
              <button
                type='button'
                className='btn-close ms-auto'
                aria-label='Close'
                onClick={onClose}
              ></button>
            )}
          </div>

          <div className='modal-body'>{children}</div>
          <div className='modal-footer'>
            <div className='d-flex justify-content-between w-100 gap-3'>
              {onClose && (
                <button
                  type='button'
                  className='btn btn-secondary'
                  onClick={onClose}
                >
                  Close
                </button>
              )}
               {onSave && (<button
                type='button'
                className='btn btn-primary ms-auto'
                onClick={onSave}
                disabled={isDisabled}
              >
                Save changes
              </button>
               )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;